/**
 * Total do carrinho em reais para eventos Amplitude.
 * O totalizer chega como string formatada ("R$ 10,00"); valor ausente ou
 * inválido vira 0 — nunca `NaN`/`undefined`, que a Amplitude omite no payload.
 */
export const getCartTotalValue = (total?: string | number | null): number => {
  if (typeof total === 'number') {
    return Number.isFinite(total) ? total : 0
  }

  const parsed = Number(String(total ?? '0').replace(/\D/g, '')) / 100

  return Number.isFinite(parsed) ? parsed : 0
}

/** Quantidade de SKUs distintos no carrinho (`items.length`). Sempre número. */
export const getCartItemsCount = (items?: unknown[] | null): number => {
  return Array.isArray(items) ? items.length : 0
}

/** Soma das quantidades dos itens. Sempre número. */
export const getCartItemsQuantity = (
  items?: Array<{ quantity?: number }> | null
): number => {
  if (!Array.isArray(items)) {
    return 0
  }

  return items.reduce((acc, item) => acc + (Number(item?.quantity) || 0), 0)
}
